import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { useLang } from "hooks/useLang"
import useLocalStorage from "hooks/useLocalStorage"
import { useState } from "react"
import Modal from "react-modal"

const DeleteAccount = () => {
    const { t } = useLang()
    const [open, setOpen] = useState(false)

    const [value, _] = useLocalStorage("pass_ticket_token", "")

    const deleteAccount = () => {
        const res = axios.delete(
            `${process.env.NEXT_PUBLIC_API_URL}users/delete`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${value}`,
                },
            }
        )

        return res
    }

    const { mutate } = useMutation({
        mutationKey: ["deleteAccount"],
        mutationFn: () => deleteAccount(),

        onSuccess: () => {
            localStorage.removeItem("pass_ticket_token")
            localStorage.removeItem("pass_ticket_user")
            window.location.href = "/"
        },
    })

    const customStyles = {
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            zIndex: 60,
        },
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
        },
    }
    return (
        <div>
            <Modal
                isOpen={open}
                onAfterOpen={() => {
                    document.body.style.overflow = "hidden"
                }}
                onAfterClose={() => {
                    document.body.style.overflow = "unset"
                }}
                contentLabel="Delete User Account Area"
                ariaHideApp={false}
                style={customStyles}
            >
                <div className="flex w-96 flex-col gap-8">
                    <div className="flex flex-col gap-4">
                        <h1 className="text-center text-2xl font-bold text-black">
                            {t("deactivate_my_account")}
                        </h1>
                        <p className="text-center text-black">
                            {t("deactivate_my_account_description")}
                        </p>
                    </div>
                    <div className="mt-4 flex justify-center gap-4">
                        <button
                            className="rounded-md bg-[#53B5A0] px-4 py-2 text-white"
                            onClick={() => setOpen(false)}
                        >
                            {t("cancel")}
                        </button>
                        <button
                            className="ml-2 rounded-md bg-[#F87171] px-4 py-2 text-white"
                            onClick={() => {
                                // setOpen(false)
                                mutate()
                            }}
                        >
                            {t("deactivate_my_account")}
                        </button>
                    </div>
                </div>
            </Modal>

            <button className="text-[#53B5A0]" onClick={() => setOpen(true)}>
                {t("deactivate_my_account")}
            </button>
        </div>
    )
}

export default DeleteAccount
